import { render, staticRenderFns } from "./textbook.vue?vue&type=template&id=2b797268&scoped=true&"
import script from "./textbook.vue?vue&type=script&lang=js&"
export * from "./textbook.vue?vue&type=script&lang=js&"
import style0 from "./textbook.vue?vue&type=style&index=0&id=2b797268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b797268",
  null
  
)

export default component.exports